// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.private-route-root {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.private-route-root header {
  padding: 8px;
  border-bottom: 1px solid #aaa;
}

.private-route-root .private-route-content {
  flex: 1;
  height: 100%;
}

.private-route-error {
  padding: 1em;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/auth/private-route.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".private-route-root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.private-route-root header {\n  padding: 8px;\n  border-bottom: 1px solid #aaa;\n}\n\n.private-route-root .private-route-content {\n  flex: 1;\n  height: 100%;\n}\n\n.private-route-error {\n  padding: 1em;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
